<template>
  <div class="admin-container">
    <AdminSidebar :isOpen="isSidebarOpen" :userData="currentUser" />
    <div class="main-content" :class="{ 'content-shifted': isSidebarOpen }">
      <nav class="admin-nav"><button class="menu-btn" @click="toggleSidebar"><i class="fas fa-bars"></i></button></nav>
      <div class="admin-content">
        <div class="config-container">
          <div class="header">
            <h1>Cấu hình SePay</h1>
            <button class="add-btn" @click="openAdd"><i class="fas fa-plus"></i> Thêm cấu hình</button>
          </div>
          <div class="table-container">
            <div v-if="loading" class="table-loading"><div class="table-spinner"></div><p>Đang tải...</p></div>
            <div v-else-if="configs.length === 0" class="table-empty"><i class="fas fa-cog table-empty-icon"></i><h3 class="table-empty-title">Chưa có cấu hình</h3></div>
            <div v-else class="table-responsive has-mobile-cards">
              <table class="admin-table">
                <thead><tr><th>Tên</th><th>Base URL</th><th>Client ID</th><th>Provider</th><th>Template</th><th>Series</th><th>Active</th><th class="col-actions">Thao tác</th></tr></thead>
                <tbody>
                  <tr v-for="cfg in configs" :key="cfg.config_id">
                    <td><strong>{{ cfg.name }}</strong></td><td>{{ cfg.api_base_url }}</td><td class="code-cell">{{ cfg.client_id }}</td><td class="code-cell">{{ cfg.provider_account_id?.slice(0,12) }}...</td><td>{{ cfg.template_code }}</td><td>{{ cfg.invoice_series }}</td>
                    <td><span :class="cfg.is_active ? 'badge badge-active' : 'badge badge-inactive'">{{ cfg.is_active ? 'Active' : '-' }}</span></td>
                    <td><button @click="edit(cfg)" class="action-btn"><i class="fas fa-edit"></i></button><button v-if="!cfg.is_active" @click="activate(cfg.config_id)" class="action-btn" style="color:#059669"><i class="fas fa-check"></i></button></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal" v-if="showForm" @click.self="showForm = false">
      <div class="modal-content modal-md">
        <div class="modal-header"><h2><i class="fas fa-cog"></i> {{ editingId ? 'Sửa' : 'Thêm' }} cấu hình</h2><button class="close-btn" @click="showForm = false"><i class="fas fa-times"></i></button></div>
        <div class="modal-body">
          <form @submit.prevent="save">
            <div class="form-group"><label>Tên <span class="required">*</span></label><input v-model="form.name" class="form-control" required /></div>
            <div class="form-group">
              <label>API Base URL <span class="required">*</span></label>
              <select v-model="form.api_base_url" class="form-control"><option value="https://einvoice-api-sandbox.sepay.vn">Sandbox (test)</option><option value="https://einvoice-api.sepay.vn">Production</option></select>
            </div>
            <div class="form-row">
              <div class="form-group"><label>Client ID <span class="required">*</span></label><input v-model="form.client_id" class="form-control" required /></div>
              <div class="form-group"><label>Client Secret <span class="required">*</span></label><input v-model="form.client_secret" type="password" class="form-control" required /></div>
            </div>
            <div class="form-group" style="margin-top:4px">
              <button type="button" @click="loadProviders" :disabled="fetchingP || !form.client_id || !form.client_secret" class="btn btn-secondary" style="width:100%"><i :class="fetchingP ? 'fas fa-spinner fa-spin' : 'fas fa-download'"></i> {{ fetchingP ? 'Đang lấy...' : 'Lấy danh sách Provider' }}</button>
            </div>
            <div class="form-group" v-if="providers.length">
              <label>Provider Account <span class="required">*</span></label>
              <select v-model="form.provider_account_id" @change="onProviderChange" class="form-control"><option value="">-- Chọn --</option><option v-for="p in providers" :key="p.id" :value="p.id">{{ p.provider }} ({{ p.id.slice(0,8) }})</option></select>
            </div>
            <div class="form-group" v-else><label>Provider Account ID <span class="required">*</span></label><input v-model="form.provider_account_id" class="form-control" required /></div>
            <div class="form-group" v-if="templates.length">
              <label>Template</label>
              <select v-model="selectedTemplate" @change="onTemplateChange" class="form-control"><option value="">-- Chọn --</option><option v-for="t in templates" :key="t.template_code" :value="t.template_code">{{ t.invoice_label }}</option></select>
            </div>
            <div class="form-row">
              <div class="form-group"><label>Template Code <span class="required">*</span></label><input v-model="form.template_code" class="form-control" :readonly="templates.length > 0 && !!selectedTemplate" required /></div>
              <div class="form-group"><label>Invoice Series <span class="required">*</span></label><input v-model="form.invoice_series" class="form-control" :readonly="templates.length > 0 && !!selectedTemplate" required /></div>
            </div>
            <div class="modal-footer">
              <button type="button" @click="showForm = false" class="btn btn-secondary">Hủy</button>
              <button type="submit" class="btn btn-primary"><i class="fas fa-save"></i> Lưu</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AdminSidebar from '@/components/common/AdminSidebar.vue'
import { ToastService } from '@/services/ToastService'
import axios from '../../plugins/axios'

export default {
  name: 'AdminInvoiceConfig',
  components: { AdminSidebar },
  data() { return { isSidebarOpen: true, currentUser: {}, configs: [], loading: false, showForm: false, editingId: null, fetchingP: false, providers: [], templates: [], selectedTemplate: '', form: { name: '', api_base_url: 'https://einvoice-api-sandbox.sepay.vn', client_id: '', client_secret: '', provider_account_id: '', template_code: '', invoice_series: '' } } },
  mounted() { this.loadUser(); this.load() },
  methods: {
    loadUser() { try { const t = localStorage.getItem('adminToken'); if (t) this.currentUser = JSON.parse(atob(t.split('.')[1])) } catch (e) {} },
    toggleSidebar() { this.isSidebarOpen = !this.isSidebarOpen },
    reset() { this.form = { name: '', api_base_url: 'https://einvoice-api-sandbox.sepay.vn', client_id: '', client_secret: '', provider_account_id: '', template_code: '', invoice_series: '' }; this.providers = []; this.templates = []; this.selectedTemplate = '' },
    openAdd() { this.editingId = null; this.reset(); this.showForm = true },
    async load() { this.loading = true; try { const r = await axios.get('/admin/invoice-configs'); this.configs = r.data } finally { this.loading = false } },
    edit(cfg) { this.editingId = cfg.config_id; this.reset(); this.form = { name: cfg.name, api_base_url: cfg.api_base_url, client_id: cfg.client_id, client_secret: '', provider_account_id: cfg.provider_account_id, template_code: cfg.template_code, invoice_series: cfg.invoice_series }; this.showForm = true },
    async loadProviders() {
      this.fetchingP = true
      try { const r = await axios.post('/admin/invoice-configs/fetch-providers', { api_base_url: this.form.api_base_url, client_id: this.form.client_id, client_secret: this.form.client_secret }); this.providers = r.data.accounts; ToastService.success('Lấy ' + this.providers.length + ' provider') }
      catch (e) { ToastService.error('Lỗi: ' + (e.response?.data?.detail || e.message)) } finally { this.fetchingP = false }
    },
    async onProviderChange() {
      this.templates = []; this.selectedTemplate = ''
      if (!this.form.provider_account_id) return
      try { const r = await axios.post('/admin/invoice-configs/fetch-templates', { api_base_url: this.form.api_base_url, client_id: this.form.client_id, client_secret: this.form.client_secret, provider_account_id: this.form.provider_account_id }); this.templates = r.data.templates }
      catch (e) { ToastService.error('Lỗi: ' + (e.response?.data?.detail || e.message)) }
    },
    onTemplateChange() { const t = this.templates.find(x => x.template_code === this.selectedTemplate); if (t) { this.form.template_code = t.template_code; this.form.invoice_series = t.invoice_series } },
    async save() {
      try {
        const payload = { ...this.form }
        if (this.editingId && !payload.client_secret) delete payload.client_secret
        if (this.editingId) { await axios.put('/admin/invoice-configs/' + this.editingId, payload) } else { await axios.post('/admin/invoice-configs', payload) }
        this.showForm = false; this.load(); ToastService.success('Đã lưu')
      } catch (e) { ToastService.error('Lỗi: ' + (e.response?.data?.detail || e.message)) }
    },
    async activate(id) { try { await axios.post('/admin/invoice-configs/' + id + '/activate'); this.load(); ToastService.success('Đã kích hoạt') } catch (e) { ToastService.error('Lỗi: ' + (e.response?.data?.detail || e.message)) } },
  },
}
</script>

<style scoped>
.badge { display: inline-block; padding: 2px 10px; border-radius: 12px; font-size: 11px; font-weight: 600; }
.badge-active { background: #d1fae5; color: #065f46; }
.badge-inactive { background: #f3f4f6; color: #6b7280; }
.action-btn { display: inline-flex; align-items: center; gap: 4px; padding: 4px 10px; border: 1px solid #d1d5db; border-radius: 6px; background: #fff; cursor: pointer; font-size: 12px; }
.action-btn:hover { background: #f3f4f6; }
.code-cell { font-family: 'SF Mono', Monaco, monospace; font-size: 12px; color: #6b7280; }
.form-row { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; }
.btn { padding: 8px 16px; border: 1px solid #d1d5db; border-radius: 6px; cursor: pointer; font-size: 13px; }
.btn-primary { background: #283e37; color: #fff; border-color: #283e37; }
.btn-secondary { background: #f3f4f6; }
</style>
